import { isAxiosError } from '@/lib/axios';

const HTTP_TOO_MANY_REQUESTS = 429;

/**
 * True when the backend refused the call for rate reasons rather than for anything the user typed.
 *
 * Two independent limiters answer 429 on the auth endpoints: a fixed 5-per-minute-per-IP window on
 * `signin/request`, `signin/redeem` and `activate/redeem`, and a per-address issuance throttle of
 * 3 sign-in codes per 15 minutes. A redeem that trips either one is not a wrong code, so it must
 * not be reported as one.
 */
export const isRateLimited = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === HTTP_TOO_MANY_REQUESTS;

export const getApiErrorMessage = (error: unknown): string | undefined => {
  if (isAxiosError(error)) {
    const data: unknown = error.response?.data;
    if (typeof data === 'string' && data.trim().length > 0) {
      return data;
    }
    if (
      typeof data === 'object' &&
      data !== null &&
      'message' in data &&
      typeof (data as { message: unknown }).message === 'string'
    ) {
      return (data as { message: string }).message;
    }
    if (error.message) return error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return undefined;
};
